import styled from 'styled-components';

import { blueSphera, graySphera, whiteSphera } from 'src/utilities/UIStyles/variables/Colors';

import { fadeIn, fadeOut } from 'src/utilities/animations';

export const ModalSuccessRegisterCLABE = styled.section`
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  visibility: ${(props) => (props.showModalSuccessRegisterCLABE ? 'visible' : 'hidden')};
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100vh;
  background-color: rgb(0, 0, 0, 0.5);
  z-index: 100;
  animation: ${(props) => (props.showModalSuccessRegisterCLABE ? fadeIn : fadeOut)} 0.5s linear;
  transition: all 0.5s;

  > div {
    width: 40%;
    background-color: ${whiteSphera};
    border-radius: 5px;
    padding-top: 1%;
    padding-bottom: 2.5%;

    > div:nth-child(1) {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      width: 100%;
      padding-bottom: 1.5%;
      border-bottom: 1px solid #b7bcc7;

      > h3 {
        font-size: 1.5vw;
        color: ${graySphera};
        width: 90%;
        padding-left: 5%;
      }

      > figure {
        width: 25px;
        height: 25px;
        cursor: pointer;

        > img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }

  @media (min-width: 600px) and (max-width: 1024px) {
    > div {
      width: 80%;

      > div:nth-child(1) {
        > h3 {
        }

        > figure {
          > img {
          }
        }
      }
    }
  }

  @media (max-width: 600px) {
    > div {
      width: 90%;
      padding-top: 5%;
      padding-bottom: 5%;

      > div:nth-child(1) {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        width: 100%;
        padding-bottom: 5%;
        border-bottom: 1px solid #b7bcc7;

        > h3 {
          font-size: 4.5vw;
        }

        > figure {
          > img {
          }
        }
      }
    }
  }
`;

export const RegisterCLABEAdvice = styled.div`
  width: 90%;
  margin: 2.5% auto 0 auto;

  > div:nth-child(1) {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 80%;
    margin: auto;

    > figure {
      width: 40px;
      height: 40px;
      margin-right: 5%;

      > img {
        width: 100%;
        height: 100%;
      }
    }

    > p {
      font-size: 1.2vw;
      color: ${graySphera};
    }
  }

  > a {
    display: block;
    color: ${whiteSphera};
    font-weight: bold;
    font-size: 1.2vw;
    text-align: center;
    text-decoration: none;
    line-height: 40px;
    width: 30%;
    height: 40px;
    margin: 5% auto 0 auto;
    border: none;
    border-radius: 5px;
    background-color: ${blueSphera};
    cursor: pointer;
  }

  @media (min-width: 600px) and (max-width: 1024px) {
    > div:nth-child(1) {
      > figure {
        > img {
        }
      }

      > p {
      }
    }

    > a {
    }
  }

  @media (max-width: 600px) {
    margin: 5% auto 0 auto;

    > div:nth-child(1) {
      width: 100%;

      > figure {
        margin-left: 5%;

        > img {
        }
      }

      > p {
        font-size: 4.2vw;
        color: ${graySphera};
      }
    }

    > a {
      font-size: 4.2vw;
      width: 100%;
    }
  }
`;
